"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollContext = exports.scrollContextDefault = exports.useScrollContext = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
/**
 * @internal
 */
exports.useScrollContext = function () { return react_1.useContext(exports.ScrollContext); };
/**
 * @internal
 */
exports.scrollContextDefault = {
    scrollIntoView: function (_element, _bottomMargin, _isElementInvisibleCheck) { },
};
exports.ScrollContext = react_1.default.createContext(exports.scrollContextDefault);
//# sourceMappingURL=ScrollContext.js.map